import { useEffect, useRef } from "react";
import { site } from "../data/site";

const LEAFLET_CSS = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
const LEAFLET_JS = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
const ICON_BASE = "https://unpkg.com/leaflet@1.9.4/dist/images";

function loadLeaflet() {
  return new Promise((resolve) => {
    if (window.L) return resolve(window.L);
    if (!document.querySelector(`link[href="${LEAFLET_CSS}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = LEAFLET_CSS;
      document.head.appendChild(link);
    }
    let s = document.querySelector(`script[src="${LEAFLET_JS}"]`);
    if (s) {
      if (window.L) return resolve(window.L);
      s.addEventListener("load", () => resolve(window.L));
      return;
    }
    s = document.createElement("script");
    s.src = LEAFLET_JS;
    s.onload = () => resolve(window.L);
    document.body.appendChild(s);
  });
}

export const LocationsMap = () => {
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    loadLeaflet().then((L) => {
      if (cancelled || !containerRef.current || mapRef.current) return;

      delete L.Icon.Default.prototype._getIconUrl;
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: `${ICON_BASE}/marker-icon-2x.png`,
        iconUrl: `${ICON_BASE}/marker-icon.png`,
        shadowUrl: `${ICON_BASE}/marker-shadow.png`,
      });

      const map = L.map(containerRef.current, { scrollWheelZoom: false });
      mapRef.current = map;

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
        maxZoom: 19,
      }).addTo(map);

      const markers = site.clinics.map((c) =>
        L.marker([c.lat, c.lng])
          .addTo(map)
          .bindPopup(`<strong>${c.name}</strong><br>${c.address}`)
      );
      const group = L.featureGroup(markers);
      map.fitBounds(group.getBounds().pad(0.25));
      setTimeout(() => map.invalidateSize(), 200);
    });

    return () => {
      cancelled = true;
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      data-testid="service-map"
      className="absolute inset-0 h-full w-full"
    />
  );
};
